// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PhotosUploadScreen":"qa_a bhe_ea bhe_qr bhe_a bhe_w"};